import { UserSearchParams } from './types';

export const superAdminKeys = {
  reseller: () => ['RESELLER'],
  customers: (id: string) => ['CUSTOMERS', id],
  all_customers: () => ['USERS'],
  users: (customerId: string, departmentId: string) => [
    'USERS',
    customerId,
    departmentId,
  ],
  user_search: (params: UserSearchParams) => ['USER_SEARCH', params],
  all_users: () => ['CUSTOMERS'],
  departments: (id: string) => ['DEPARTMENTS', id],
};
